import { UserRole } from '@/constants/commons.ts'

export default () => [
  {
    path: '/',
    children: [
      // HOME
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.CUSTOMER]
        }
      },
      // PROFILE
      {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.CUSTOMER]
        }
      },
      // ADMINISTRATORS
      {
        path: '/administrators',
        name: 'administrators',
        component: () => import('@/views/administrators/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Amministratori'
        }
      },
      {
        path: '/administrators/create',
        name: 'administrators_create',
        component: () => import('@/views/administrators/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN],
          breadcrumb: 'Creazione amministratore'
        }
      },
      {
        path: '/administrators/:id',
        name: 'administrator',
        component: () => import('@/views/administrators/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio amministratore'
        }
      },
      {
        path: '/administrators/:id/update',
        name: 'administrators_update',
        component: () => import('@/views/administrators/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento amministratore'
        }
      },
      // CUSTOMERS
      {
        path: '/customers',
        name: 'customers',
        component: () => import('@/views/customers/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Clienti'
        }
      },
      {
        path: '/customers/create',
        name: 'customers_create',
        component: () => import('@/views/customers/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN],
          breadcrumb: 'Creazione cliente'
        }
      },
      {
        path: '/customers/:id',
        name: 'customer',
        component: () => import('@/views/customers/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio cliente'
        }
      },
      {
        path: '/customers/:id/update',
        name: 'customers_update',
        component: () => import('@/views/customers/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento cliente'
        }
      },
      {
        path: '/customers/:customer_id/create_device',
        name: 'customers_create_device',
        component: () => import('@/views/customers/create_device.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione dispositivo'
        }
      },
      // OPERATORS
      {
        path: '/operators',
        name: 'operators',
        component: () => import('@/views/operators/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Operatori'
        }
      },
      {
        path: '/operators/create',
        name: 'operators_create',
        component: () => import('@/views/operators/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN],
          breadcrumb: 'Creazione operatore'
        }
      },
      {
        path: '/operators/:id',
        name: 'operator',
        component: () => import('@/views/operators/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio operatore'
        }
      },
      {
        path: '/operators/:id/update',
        name: 'operators_update',
        component: () => import('@/views/operators/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento operatore'
        }
      },
      // ADDITIONAL EMAILS
      {
        path: '/additional_emails',
        name: 'additional_emails',
        component: () => import('@/views/additional_emails/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Email aggiuntive'
        }
      },
      {
        path: '/additional_emails/create',
        name: 'additional_emails_create',
        component: () => import('@/views/additional_emails/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione email aggiuntive'
        }
      },
      {
        path: '/additional_emails/:id',
        name: 'additional_email',
        component: () => import('@/views/additional_emails/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio email aggiuntiva'
        }
      },
      {
        path: '/additional_emails/:id/update',
        name: 'additional_emails_update',
        component: () => import('@/views/additional_emails/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento email aggiuntive'
        }
      },
      // DEVICES
      {
        path: '/devices',
        name: 'devices',
        component: () => import('@/views/devices/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco dispositivi'
        }
      },
      {
        path: '/devices/create',
        name: 'devices_create',
        component: () => import('@/views/devices/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione dispositivo'
        }
      },
      {
        path: '/devices/:id',
        name: 'device',
        component: () => import('@/views/devices/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio dispositivo'
        }
      },
      {
        path: '/devices/:id/update',
        name: 'devices_update',
        component: () => import('@/views/devices/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento dispositivo'
        }
      },
      // REGISTERS
      {
        path: '/registers',
        name: 'registers',
        component: () => import('@/views/registers/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco registri'
        }
      },
      {
        path: '/registers/create',
        name: 'registers_create',
        component: () => import('@/views/registers/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione frontespizio'
        }
      },
      {
        path: '/registers/:id',
        name: 'register',
        component: () => import('@/views/registers/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio frontespizio'
        }
      },
      {
        path: '/registers/:id/update',
        name: 'registers_update',
        component: () => import('@/views/registers/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento frontespizio'
        }
      },
      // REQUESTS
      {
        path: '/requests',
        name: 'requests',
        component: () => import('@/views/requests/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco pagine registro'
        }
      },
      {
        path: '/requests/create',
        name: 'requests_create',
        component: () => import('@/views/requests/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione pagine registro'
        }
      },
      {
        path: '/requests/:id',
        name: 'request',
        component: () => import('@/views/requests/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio pagina registro'
        }
      },
      {
        path: '/requests/:id/update',
        name: 'requests_update',
        component: () => import('@/views/requests/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento pagina registro'
        }
      },
      // TRANSMISSIONS
      {
        path: '/transmissions',
        name: 'transmissions',
        component: () => import('@/views/transmissions/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco trasmissioni'
        }
      },
      {
        path: '/transmissions/create',
        name: 'transmissions_create',
        component: () => import('@/views/transmissions/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione trasmissione'
        }
      },
      {
        path: '/transmissions/:id',
        name: 'transmission',
        component: () => import('@/views/transmissions/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio trasmissione'
        }
      },
      {
        path: '/transmissions/:id/update',
        name: 'transmissions_update',
        component: () => import('@/views/transmissions/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento trasmissione'
        }
      },
      // NOTES
      {
        path: '/notes',
        name: 'notes',
        component: () => import('@/views/notes/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco note'
        }
      },
      {
        path: '/notes/create',
        name: 'notes_create',
        component: () => import('@/views/notes/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione nota'
        }
      },
      {
        path: '/notes/:id',
        name: 'note',
        component: () => import('@/views/notes/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio nota'
        }
      },
      {
        path: '/notes/:id/update',
        name: 'notes_update',
        component: () => import('@/views/notes/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento nota'
        }
      },
      // CUSTOMS OFFICES
      {
        path: '/customs_offices',
        name: 'customs_offices',
        component: () => import('@/views/customs_offices/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco dogane'
        }
      },
      {
        path: '/customs_offices/create',
        name: 'customs_offices_create',
        component: () => import('@/views/customs_offices/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione dogana'
        }
      },
      {
        path: '/customs_offices/:id',
        name: 'customs_office',
        component: () => import('@/views/customs_offices/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio dogana'
        }
      },
      {
        path: '/customs_offices/:id/update',
        name: 'customs_offices_update',
        component: () => import('@/views/customs_offices/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento dogana'
        }
      },
      // FILTERS
      {
        path: '/filters',
        name: 'filters',
        component: () => import('@/views/filters/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Elenco filtri'
        }
      },
      {
        path: '/filters/create',
        name: 'filters_create',
        component: () => import('@/views/filters/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Creazione filtro'
        }
      },
      {
        path: '/filters/:id',
        name: 'filter',
        component: () => import('@/views/filters/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Dettaglio filtro'
        }
      },
      {
        path: '/filters/:id/update',
        name: 'filters_update',
        component: () => import('@/views/filters/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
          breadcrumb: 'Aggiornamento filtro'
        }
      },
      // DEVICE ANOMALIES
      {
        path: '/device_anomalies',
        name: 'device_anomalies',
        component: () => import('@/views/device_anomalies/index.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.CUSTOMER],
          breadcrumb: 'Elenco anomalie dispositivi'
        }
      },
      {
        path: '/device_anomalies/create',
        name: 'device_anomalies_create',
        component: () => import('@/views/device_anomalies/create.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.CUSTOMER],
          breadcrumb: 'Creazione anomalia dispositivo'
        }
      },
      {
        path: '/device_anomalies/:id',
        name: 'device_anomaly',
        component: () => import('@/views/device_anomalies/show.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.CUSTOMER],
          breadcrumb: 'Dettaglio anomalia dispositivo'
        }
      },
      {
        path: '/device_anomalies/:id/update',
        name: 'device_anomalies_update',
        component: () => import('@/views/device_anomalies/update.vue'),
        meta: {
          requiresAuth: true,
          roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.CUSTOMER],
          breadcrumb: 'Aggiornamento anomalia dispositivo'
        }
      }
    ]
  },
  {
    path: '/access_denied',
    name: 'access_denied',
    component: () => import('@/views/auth/AccessDenied.vue')
  }
]
